"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkedProvider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var UserContext_1 = __importDefault(require("./UserContext"));
var Vacancy_1 = __importDefault(require("../models/Vacancy"));
var defaultBookmark = {
    bookmarks: new Set(),
    handleToggleBookmark: function () { return undefined; },
    isLiked: function () { return false; },
};
var get = function () {
    var _a, _b;
    axios_1.default.post('/data/bookmarked-vacancies/session', {
        vacancyIds: JSON.parse((_a = localStorage.getItem('bookmarks')) !== null && _a !== void 0 ? _a : '[]'),
    });
    return new Set(JSON.parse((_b = localStorage.getItem('bookmarks')) !== null && _b !== void 0 ? _b : '[]'));
};
var BookmarkedContext = react_1.default.createContext(defaultBookmark);
function BookmarkedProvider(_a) {
    var children = _a.children;
    var userId = (0, react_1.useContext)(UserContext_1.default).userId;
    var _b = (0, react_query_1.useQuery)('bookmarked', function () { return axios_1.default.get('/data/bookmarked-vacancies/ids'); }, {
        enabled: !!userId,
    }), isLoading = _b.isLoading, error = _b.error, data = _b.data;
    var _c = (0, react_1.useState)(get()), bookmarks = _c[0], setBookmarks = _c[1];
    (0, react_1.useEffect)(function () {
        if (isLoading || error || !userId || !data || !data.data) {
            return;
        }
        setBookmarks(new Set(data.data));
        localStorage.setItem('bookmarks', JSON.stringify(data.data));
    }, [isLoading, error, userId]);
    var isLiked = function (vacancyId) {
        return bookmarks.has(vacancyId);
    };
    var handleToggleBookmark = function (vacancyId) {
        if (!vacancyId) {
            return;
        }
        if (isLiked(vacancyId)) {
            bookmarks.delete(vacancyId);
        }
        else {
            bookmarks.add(vacancyId);
        }
        if (userId) {
            Vacancy_1.default.registerLike(vacancyId);
        }
        localStorage.setItem('bookmarks', JSON.stringify(bookmarks));
        setBookmarks(get());
    };
    return (0, jsx_runtime_1.jsx)(BookmarkedContext.Provider, __assign({ value: { bookmarks: bookmarks, handleToggleBookmark: handleToggleBookmark, isLiked: isLiked } }, { children: children }));
}
exports.BookmarkedProvider = BookmarkedProvider;
exports.default = BookmarkedContext;
